export const queryKeys = {
  dashboard: ['dashboard'] as const,

  nodes: {
    all: ['nodes'] as const,
    list: () => [...queryKeys.nodes.all, 'list'] as const,
    detail: (id: string) => [...queryKeys.nodes.all, 'detail', id] as const,
  },

  users: {
    all: ['users'] as const,
    list: () => [...queryKeys.users.all, 'list'] as const,
    detail: (id: string) => [...queryKeys.users.all, 'detail', id] as const,
  },

  ipPool: {
    all: ['ip-pool'] as const,
    list: (filters?: IpPoolFilters) => [...queryKeys.ipPool.all, 'list', filters] as const,
  },

  alerts: {
    all: ['alerts'] as const,
    list: (filters?: AlertFilters) => [...queryKeys.alerts.all, 'list', filters] as const,
  },

  rotations: {
    all: ['rotations'] as const,
    list: (filters?: RotationFilters) => [...queryKeys.rotations.all, 'list', filters] as const,
  },

  healthChecks: {
    all: ['health-checks'] as const,
    list: (filters?: HealthCheckFilters) => [...queryKeys.healthChecks.all, 'list', filters] as const,
  },
} as const

export interface IpPoolFilters {
  provider?: string
  region?: string
  status?: string
}

export interface AlertFilters {
  severity?: string
  acknowledged?: boolean
  nodeId?: string
}

export interface RotationFilters {
  nodeId?: string
  success?: boolean
  limit?: number
  offset?: number
}

export interface HealthCheckFilters {
  nodeId?: string
  checkType?: string
  success?: boolean
  limit?: number
  offset?: number
}
